import React, { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

const norm = (s) => (s || "").toLowerCase().replace(/\s+/g, " ").trim();

export function useEventiAperti() {
  const { selectedStructure, user } = useAuth();
  const { data = [] } = useQuery({
    queryKey: ["eventi-aperti", selectedStructure],
    enabled: !!user,
    staleTime: 60000,
    refetchInterval: 120000,
    queryFn: async () => (await api.get("/dashboard/eventi-aperti", { params: selectedStructure && selectedStructure !== "all" ? { structure_id: selectedStructure } : {} })).data,
  });
  return React.useMemo(() => {
    const byId = {}, byName = {};
    data.forEach((e) => {
      byId[e.ospite_id] = e.evento;
      byName[norm(`${e.cognome} ${e.nome}`)] = e.evento;
      byName[norm(`${e.nome} ${e.cognome}`)] = e.evento;
    });
    return { byId, byName };
  }, [data]);
}

export function EsBadge({ id, nome }) {
  const { byId, byName } = useEventiAperti();
  const [open, setOpen] = useState(null);
  useEffect(() => {
    if (!open) return undefined;
    const close = () => setOpen(null);
    window.addEventListener("scroll", close, true);
    const t = setTimeout(() => document.addEventListener("pointerdown", close), 0);
    return () => { clearTimeout(t); window.removeEventListener("scroll", close, true); document.removeEventListener("pointerdown", close); };
  }, [open]);
  const evento = (id && byId[id]) || (nome && byName[norm(nome)]);
  if (!evento) return null;
  const tid = id || norm(nome).replace(/ /g, "-");
  const show = (e) => { const r = e.currentTarget.getBoundingClientRect(); setOpen({ x: r.left, y: r.bottom + 4 }); };
  return (
    <span className="inline-flex items-center gap-0.5 ml-1 align-middle text-[9px] font-bold text-red-600 leading-none shrink-0 cursor-pointer select-none"
      data-testid={`es-badge-${tid}`} aria-label={`Evento sanitario: ${evento}`}
      onPointerEnter={(e) => { if (e.pointerType === "mouse") show(e); }} onPointerLeave={(e) => { if (e.pointerType === "mouse") setOpen(null); }}
      onClick={(e) => { e.stopPropagation(); e.preventDefault(); if (e.nativeEvent.pointerType === "mouse") return; if (open) setOpen(null); else show(e); }}>
      E.S.
      <svg width="9" height="9" viewBox="0 0 10 10" aria-hidden="true"><path d="M3.5 0h3v3.5H10v3H6.5V10h-3V6.5H0v-3h3.5z" fill="#dc2626" /></svg>
      {open && (
        <span style={{ position: "fixed", left: Math.min(open.x, window.innerWidth - 220), top: open.y }} className="z-[100] whitespace-nowrap rounded-md bg-slate-900 px-2 py-1 text-[11px] font-semibold text-white shadow-lg" data-testid={`es-tooltip-${tid}`}>
          Evento sanitario: {evento}
        </span>
      )}
    </span>
  );
}
